import { initializeSearchForm } from './shared.js';

const jsDropDownSelector = '.js-drop-down';

export const initializeDesktopHeader = () => {
    const parentHeader = document.querySelector('header.js-desktop-header');
    if (!parentHeader) {
        return;
    }

    initializeSearchForm(parentHeader);
    initializeSeachToggle(parentHeader);
    initializeTabletMenuBehaviour(parentHeader);
};

const initializeTabletMenuBehaviour = (parent) => {
    const megaMenuLinks = parent.querySelectorAll('.js-has-drop-down > a');
    if (megaMenuLinks.length === 0) {
        return;
    }

    window.addEventListener('touchend', (event) => {
        megaMenuLinks.forEach(link => {
            const dropDown = link.parentElement.querySelector(jsDropDownSelector);
            if (!link.parentElement.contains(event.target) && dropDown) {
                dropDown.style.display = 'none';
            }
        });
    });

    megaMenuLinks.forEach(link => {
        link.addEventListener('touchend', (event) => {
            event.preventDefault();
            const dropDown = link.parentElement.querySelector(jsDropDownSelector);
            if (dropDown) {
                dropDown.style.display = 'block';
            }
        })
    })
}

const initializeSeachToggle = (parentHeader) => {
    const searchContainer = parentHeader.querySelector('.js-search');
    const searchToggleButtons = parentHeader.querySelectorAll('.js-search-toggle');
    const searchInput = parentHeader.querySelector('.js-header-search-input');
    const navItems = parentHeader.querySelectorAll('.js-nav-item');
    if (!searchContainer || searchToggleButtons.length === 0) {
        return;
    }

    searchToggleButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            searchContainer.classList.toggle('open');
            navItems.forEach(item => item.classList.toggle('opacity-0'));
            
            if (searchContainer.classList.contains('open')) {
                searchInput.focus();
            } else {
                searchInput.blur();
            }
        });
    });
}